import { render, staticRenderFns } from "./aidtl.vue?vue&type=template&id=10eaaf02&scoped=true&"
import script from "./aidtl.vue?vue&type=script&lang=js&"
export * from "./aidtl.vue?vue&type=script&lang=js&"
import style0 from "./aidtl.vue?vue&type=style&index=0&id=10eaaf02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eaaf02",
  null
  
)

export default component.exports